import { FLAG_VISITOR_EXPOSED, METHOD_DEACTIVATED_CONSENT_ERROR } from '../enum/index';
import { logInfo, sprintf } from '../utils/utils';
import { DefaultStrategy } from './DefaultStrategy';
export class NoConsentStrategy extends DefaultStrategy {
    async lookupHits() {
        //
    }
    async lookupVisitor() {
        //
    }
    async cacheVisitor() {
        //
    }
    async cacheHit() {
        //
    }
    async collectEAIEventsAsync() {
        this.log('collectEAIData');
    }
    reportEaiPageView() {
        //
    }
    reportEaiVisitorEvent() {
        //
    }
    onEAICollectStatusChange() {
        //
    }
    fetchCampaignsFromCache() {
        return [];
    }
    async sendHit(_hit) {
        this.log('sendHit');
    }
    async sendHits(_hits) {
        this.log('sendHits');
    }
    async sendActivate(_flagDto, _defaultValue) {
        //
    }
    async visitorExposed() {
        this.log(FLAG_VISITOR_EXPOSED);
    }
    async sendTroubleshootingHit() {
        //
    }
    async addInTrackingManager() {
        //
    }
    log(methodName) {
        logInfo(this.config, sprintf(METHOD_DEACTIVATED_CONSENT_ERROR, methodName, this.visitor.visitorId), methodName);
    }
}
